import { BannersDto } from 'types/dtos/banner'

import { api } from './api'

export const dismissBanner = (type: keyof BannersDto) => api.post(`/banners/${type}/dismissed`)
